Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrandContextTypes = exports.BrandPropType = exports.BRAND_LUXURY = exports.BRAND_SELECT = exports.BRAND_DEFAULT = exports.BRAND_CONTEXT_KEY = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = require('airbnb-prop-types');

var _brcast = require('brcast');

var _brcast2 = _interopRequireDefault(_brcast);

var _brcast3 = require('../shapes/brcast');

var _brcast4 = _interopRequireDefault(_brcast3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BRAND_CONTEXT_KEY = exports.BRAND_CONTEXT_KEY = '___ airbnb brand context enum ___';
var BRAND_DEFAULT = exports.BRAND_DEFAULT = 'default';
var BRAND_SELECT = exports.BRAND_SELECT = 'select';
var BRAND_LUXURY = exports.BRAND_LUXURY = 'luxury';

var BrandPropType = exports.BrandPropType = _propTypes2['default'].oneOf([BRAND_DEFAULT, BRAND_SELECT, BRAND_LUXURY]);

var propTypes = {
  brand: BrandPropType,
  children: _propTypes2['default'].node.isRequired
};

var defaultProps = {
  brand: BRAND_DEFAULT
};

var childContextTypes = _defineProperty({}, BRAND_CONTEXT_KEY, _brcast4['default'].isRequired);

var BrandContextTypes = exports.BrandContextTypes = _defineProperty({}, BRAND_CONTEXT_KEY, _brcast4['default']);

var BrandProvider = function (_React$Component) {
  _inherits(BrandProvider, _React$Component);

  function BrandProvider(props) {
    _classCallCheck(this, BrandProvider);

    var _this = _possibleConstructorReturn(this, (BrandProvider.__proto__ || Object.getPrototypeOf(BrandProvider)).call(this, props));

    _this.broadcast = (0, _brcast2['default'])(props.brand);
    return _this;
  }

  _createClass(BrandProvider, [{
    key: 'getChildContext',
    value: function () {
      function getChildContext() {
        return _defineProperty({}, BRAND_CONTEXT_KEY, this.broadcast);
      }

      return getChildContext;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var brand = this.props.brand;

        if (brand !== nextProps.brand) {
          this.broadcast.setState(nextProps.brand);
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var children = this.props.children;

        return _react2['default'].Children.only(children);
      }

      return render;
    }()
  }]);

  return BrandProvider;
}(_react2['default'].Component);

exports['default'] = BrandProvider;


BrandProvider.propTypes = (0, _airbnbPropTypes.forbidExtraProps)(propTypes);
BrandProvider.defaultProps = defaultProps;
BrandProvider.childContextTypes = childContextTypes;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/themes/BrandProvider.js
// module id = 438
// module chunks = 168707334958949